{
  "application": {
    "error": {
      "description": "Bei der Bearbeitung deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es erneut.",
      "title": "Fehler"
    }
  },
  "client": {
    "noSupport": "Dein Browser hat anscheinend ein Problem mit der eingesetzten Technik. Bitte überprüfe die Einstellungen oder benutze einen Browser der neusten Generation."
  },
  "documentUploadStep": {
    "errorText": {
      "client": "Dein Browser hat anscheinend ein Problem mit der eingesetzten Technik.",
      "empty": "Einige deiner Dokumente konnten nicht hochgeladen werden. Bitte wähle sie erneut aus, bevor du fortfährst.",
      "score": "Breite und/oder Höhe des Bildes sind ungenügend. Mindestanforderung: {minDimension}",
      "size": "Die Datei ist zu gross. Maximal: {maxFileSize}.",
      "title": "Hinweis",
      "type": "Der Typ der Datei ist nicht korrekt. Erlaubte Dateitypen: {allowedFileTypes}."
    },
    "filePlaceholder": {
      "message": "Klicken oder Bilddatei hier ablegen"
    },
    "helper": {
      "fileBack": "Ein Foto der Rückseite deines Dokumentes (Personalausweis, ID). Beachte bitte die Qualität des Bildes.",
      "fileFront": "Ein Foto der Vorderseite deines Dokumentes (Personalausweis, ID). Beachte bitte die Qualität des Bildes.",
      "filePassport": "Ein Foto deines Dokumentes (Passport, Pass). Beachte bitte die Qualität des Bildes."
    },
    "instruction": {
      "message": "In diesem Schritt benötigen wir eine digitale Kopie deines Ausweises. Es wird kein direkter Upload gestartet, du kannst also in aller Ruhe die richtigen Bilder auswählen."
    },
    "labels": {
      "documentType": "Dokumenttyp",
      "fileBack": "Rückseite",
      "fileFront": "Vorderseite",
      "fileIdCard": "Identitätskarte (ID)",
      "fileInside": "Innere Pass-Doppelseite",
      "filePassport": "Passport (Pass)"
    },
    "messagePassport": {
      "cta": "Beispiel anzeigen",
      "text": "Lade ein Foto der vollständig geöffneten Pass-Doppelseite hoch. Name, Passnummer und <b>deine Unterschrift</b> müssen gut sichtbar sein.",
      "title": "Wichtig"
    },
    "PassportModal": {
      "text": "Lade ein Foto der vollständig geöffneten Pass-Doppelseite hoch. Neben allen persönlichen Angaben muss <b>deine Unterschrift</b> gut sichtbar sein."
    },
    "title": "Ausweis hochladen"
  },
  "howItWork": {
    "message": "Alle rechtsfähigen natürlichen Personen mit Wohnsitz in der Schweiz können den Betreibungsauszug bestellen.",
    "title": "Wie es funktioniert"
  },
  "landingFaq": {
    "title": "Häufig gestellte Fragen"
  },
  "landingHero": {
    "message": "Erspar dir den Gang zum Betreibungsamt und bestell den Betreibungsauszug bequem online.",
    "pricePure": "CHF 29.90",
    "title": "Betreibungsauszug {titleExtended}",
    "titleExtended": "jetzt online bestellen"
  },
  "landingInformation": {
    "partnerInfo": {
      "link": {
        "href": "https://www.mycrifdata.ch/",
        "label": "crif.ch"
      },
      "message": "CRIF ist in der Schweiz die führende Anbieterin von Wirtschafsinformationen und Betreibungsauskünften und unterhält den umfangreichsten Datenpool.<br><br>Mit CRIF erhältst du schnell und preiswert deinen aktuelle Betreibungsauszug und kannst diesen bequem per Rechnung zahlen.<br><br>CRIF unterstützt Privatpersonen mit <strong>myCRIFdata</strong> dabei, ihre Daten zu verifizieren und jederzeit aktuell über Änderungen informiert zu sein.",
      "providedByLabel": "Bereitgestellt von {partnerLink}",
      "title": "Wer ist CRIF?"
    },
    "priceDetail": {
      "officialFee": {
        "label": "Amtliche Gebühr",
        "value": "CHF 17.–"
      },
      "processingFee": {
        "label": "Bearbeitungsgebühr",
        "value": "CHF 12.90"
      },
      "total": {
        "label": "Total",
        "value": "CHF 29.90"
      }
    },
    "priceInfo": {
      "message": "Für die Bestellung benötigst du folgende Angaben: Persönliche Daten und Fotos eines Ausweises (ID oder Pass).<br><br>Der Betreibungsregisterauszug kann von jeder geschäftsfähigen Privatperson (natürliche Person) mit Wohnsitz in der Schweiz bestellt werden.",
      "title": "Informationen zur Bestellung"
    },
    "pricePlan": {
      "featureOne": "Keine Vorauszahlung erforderlich",
      "featureTwo": "Zahle per Rechnung",
      "title": "Preiszusammensetzung in CHF"
    },
    "tenantPlus": {
      "badge": "Plus",
      "description": "Gratis Betreibungsauszug mit ",
      "tenant": "<strong>Mieter</strong>"
    }
  },
  "landingOverview": {
    "sectionHero": {
      "message": "Erspare dir den Gang zum Betreibungsamt und bestelle einfach und bequem den Betreibungsauszug online.",
      "title": "Schnell, einfach und sorglos"
    },
    "sectionOne": {
      "message": "Füll das Formular in weniger als 5 Minuten aus.",
      "title": "Einfacher Bestellablauf"
    },
    "sectionThree": {
      "message": "Keine Vorauszahlung erforderlich.",
      "title": "Zahle per Rechnung"
    },
    "sectionTwo": {
      "message": "Keine Geschäftszeiten – jederzeit und überall bestellen.",
      "title": "Online bestellen"
    },
    "title": "Direkt in deinen Briefkasten für CHF 29.90"
  },
  "landingPage": {
    "cta": {
      "text": "Jetzt bestellen"
    }
  },
  "metaInfo": {
    "pageTitleLoadInProgress": "Prozess läuft",
    "pageTitleWizardSteps": "Schritt {currentStep}/{lastStep} | Betreibungsauszug bestellen"
  },
  "navigation": {
    "accountItem": {
      "label": "Benutzerkonto",
      "urlPath": "benutzerkonto"
    }
  },
  "personalDetailsStep": {
    "form": {
      "email": {
        "tooltip": "Die hier bereits eingefügte E-Mail-Adresse entspricht derjenigen in deinem Benutzerkonto. Falls du es wünschst, kannst du sie dort ändern."
      },
      "helpers": {
        "dateFormat": "Datumsformat: TT.MM.JJJJ"
      },
      "labels": {
        "city": "Ort",
        "dateOfBirth": "Geburtsdatum",
        "deliverPosBaByMail": "<strong>Zustellung per E-Mail erlauben</strong><br>Wir senden den Betreibungsauszug per E-Mail nur, wenn er keine Einträge enthält.",
        "email": "E-Mail",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "phoneNumber": "Telefonnummer",
        "salutation": "Anrede",
        "streetAndNumber": "Strasse / Nr.",
        "zipCode": "PLZ"
      },
      "placeholders": {
        "dateOfBirth": "z. B. 24.01.2001",
        "email": "z. B. example@mail.com",
        "phoneNumber": "z. B. +41 447118614",
        "zipCode": "z. B. 8001"
      },
      "salutationOptions": {
        "female": "Frau",
        "male": "Herr"
      },
      "validations": {
        "city": "Bitte einen Ort eingeben.",
        "dateFormat": "Ungültiges Datumsformat",
        "dateOfBirth": "Bitte dein Geburtsdatum eingeben.",
        "email": "Bitte gib deine E-Mail-Adresse ein.",
        "emailFormat": "Ungültiges E-Mail-Format",
        "firstName": "Bitte gib deinen Vornamen ein.",
        "houseNumber": "Bitte eine Hausnummer eingeben.",
        "lastName": "Bitte gib deinen Nachnamen ein.",
        "maxLength": "Zu lang (höchstens {maxLength} Zeichen)",
        "phoneNumber": "Bitte gib deine Telefonnumer ein.",
        "salutation": "Bitte wähle eine Anrede aus.",
        "streetAndNumber": "Bitte gib einen Strassennamen ein.",
        "unsupportedCharacters": "Einige Zeichen werden nicht unterstützt. Bitte entferne Emojis und Sonderzeichen.",
        "zipCode": "Bitte gib eine gültige Postleitzahl ein."
      },
      "zipCode": {
        "unavailableArea": {
          "default": "Wir können zurzeit keine Bestellungen für den Kreis 4 (Zürich) abwickeln."
        }
      }
    },
    "instruction": "Bitte die Adresse verwenden, bei der du auch offiziell angemeldet bist und für die du die Betreibungsauskunft einholen möchtest. Die Lieferung geht an die angegebene Adresse.",
    "tenantPlus": {
      "badge": "Plus",
      "freeReport": "Als MieterPlus-Benutzer kannst du 1 gratis Betreibungsauszug bestellen. Das Angebot wird beim Bezahlen berücksichtigt.",
      "notLoggedInbody": "Vorzeitiger Zugang zu exklusiven Inseraten, Besichtigungsterminen und ein gratis Betreibungsauszug. Der Betreibungsauszug ist mit Beginn des Bezahlabos verfügbar.",
      "notLoggedInCTA1": "Mehr erfahren",
      "notLoggedInCTA2": "Ich bin bereits MieterPlus-Benutzer",
      "notLoggedInHeader": "Gratis Betreibungsauszug mit",
      "serviceNameUrl": "mieterplus",
      "switchToPaid": {
        "cta": "Hol dir den Gratis-Betreibungsauszug",
        "modal": {
          "description": "Wechsel zu einem kostenpflichtigen Abonnement, um den Gratis-Betreibungsauszug zu erhalten.",
          "price": "CHF 39.95 pro Monat\n",
          "primaryCTA": "Zum Bezahlabo wechseln",
          "secondaryCTA": "Probeabo behalten",
          "serviceName": "MieterPlus",
          "startDate": "Das 3-monatige Abonnement beginnt am {startDate}.",
          "title": "Gratis Betreibungsauszug",
          "variable": {
            "price": "CHF {price} pro Monat",
            "startDate": "Das {month}-monatige Abonnement beginnt am {startDate}."
          }
        },
        "notAvailableModal": {
          "description": "Danke für dein Interesse. Wir arbeiten daran, diese Funktion bald anbieten zu können. Du kannst den Gratis-Betreibungsauszug bestellen, sobald dein Probeabo abgelaufen ist.",
          "title": "Funktion noch nicht verfügbar"
        },
        "successMessage": "Du hast zu einem kostenpflichtigen Abonnement gewechselt. Jetzt kannst du deinen Gratis-Betreibungsauszug bestellen!"
      },
      "trialMessage": "Du nutzt gerade die kostenlose Probeversion von MieterPlus. Der kostenlose Betreibungsauszug ist nur bei einem kostenpflichtigen Abonnement verfügbar.",
      "usedFreeReport": "Du hast deinen gratis Betreibungsauszug bereits angefordert. Du kannst einen neuen kostenpflichtig bestellen."
    },
    "title": "Persönliche Details"
  },
  "personalSignatureStep": {
    "instruction": {
      "message": "In diesem Schritt benötigen wir noch deine Unterschrift. Zeichne hierzu mit der Maus, einem Pencil oder mit dem Finger deine persönliche Signatur."
    },
    "title": "Unterschrift",
    "warning": {
      "maxPathsCount": "Maximale Anzahl von Zeichungen ({maxPathsCount}) erreicht!"
    }
  },
  "sendStep": {
    "deliveryAndProcess": {
      "description": {
        "1stPhrase": "Du erhältst den Betreibungsauszug innerhalb von 1 bis 2 Werktagen (abhängig vom zuständigen Betreibungsamt) per E-Mail und kurz danach auch per Post.",
        "2ndPhrase": "Antrag, Zustellung und Rechnungsstellung übernimmt unser Partner CRIF AG. Deine Daten werden vertraulich behandelt und ausser dem Betreibungsamt zum Zweck dieses Antrags keinen Dritten zugestellt."
      },
      "pdf": "Nur PDF (E-Mail)",
      "pdfAndPostal": "PDF und Versand via A-Post für zusätzliche CHF 3.–",
      "pdfAndPostalWithCertificate": "PDF und Versand via A-Post für zusätzliche CHF 5.–",
      "title": "Zustellung",
      "withUpsell": "(mit BONITÄTSZERTIFIKAT von myCRIFdata)"
    },
    "directPayment": {
      "error": {
        "text": "Bitte überprüfe deine Zahlungsinformationen und versuche es erneut oder wähle ein anderes Zahlungsmittel.",
        "title": "Wir konnten deine Zahlung nicht verarbeiten"
      }
    },
    "disclaimers": {
      "acceptTermsMessage": "Bitte akzeptiere die Nutzungsbedingungen",
      "data": {
        "content": "Hiermit bestätige ich die Richtigkeit meiner persönlichen Daten. Ich bin voll geschäftsfähig und schliesse diesen Vertrag ausschliesslich für meine eigene Person ab. Ich bin mit der Nutzung entsprechend den in der <a href=\"https://www.mycrifdata.ch/regulations/Datenschutzerklaerung_de.pdf\" target=\"_blank\" rel=\"noopener\">Datenschutzerklärung</a> gemachten Angaben einverstanden.",
        "title": "Persönliche Daten"
      },
      "generalTerms": {
        "bulletPoint1": "ermächtigen Sie die SMG Swiss Marketplace Group AG, einen Betreibungsregisterauszug über Ihre Person beim zuständigen Betreibungsamt zu bestellen; SMG ist berechtigt, hierfür die CRIF AG oder eine andere geeignete Dienstleisterin beizuziehen und zu bevollmächtigen; die Einholung erfolgt einmalig im Zusammenhang mit Ihrer konkreten Bestellung;",
        "bulletPoint3": "bestätigen Sie die Richtigkeit Ihrer Angaben und nehmen zur Kenntnis, dass weder eine Rückerstattung erfolgt noch ein Anspruch auf erneute Einreichung besteht, wenn der Betreibungsregisterauszug aufgrund fehlerhafter Angaben nicht ausgestellt werden kann;",
        "bulletPoint4": "nehmen Sie zur Kenntnis, dass Ihre Personendaten sowohl von der SMG Swiss Marketplace Group AG als auch von der CRIF AG als jeweils eigenständige Verantwortliche bearbeitet werden. Die CRIF AG kann Ihre Daten beispielsweise zur Erstellung von Bonitätsscores verwenden und diese im Rahmen der Erbringung von Kreditinformationen an Dritte weitergeben. Weitere Einzelheiten zur Bearbeitung Ihrer Daten durch die jeweiligen Verantwortlichen finden Sie in den Datenschutzerklärungen der <a href=\"https://privacy.swissmarketplace.group/de/\" target=\"_blank\" rel=\"noopener\">SMG Swiss Marketplace Group AG</a> und der <a href=\"https://www.crif.ch/datenschutz/\" target=\"_blank\" rel=\"noopener\">CRIF AG</a>.",
        "content": "Ich akzeptiere die <a href=\"https://www.mycrifdata.ch/regulations/Allgemeine%20Nutzungsbedingungen_de.pdf\" target=\"_blank\" rel=\"noopener\">Allgemeinen Nutzungsbedingungen</a> und erkläre hiermit meine Einwilligung in den Austausch personenbezogener Daten der Auskunftei CRIF mit.",
        "text": "Indem Sie fortfahren:",
        "title": "Allgemeinen Nutzungsbedingungen"
      },
      "personalDataConfirmation": {
        "content": "Ich bestätige die Richtigkeit meiner persönlichen Daten. Ich bin voll geschäftsfähig und bevollmächtige die CRIF AG, den Betreibungsauszug über meine Person beim zuständigen Betreibungsamt einzuholen. Ich nehme zur Kenntnis, dass mit dem Absenden der Bestellung ein direktes Vertragsverhältnis mit der CRIF AG zustande kommt. Die Ausführung meiner Bestellung (inklusive Rechnungsstellung) erfolgt durch die CRIF AG. Ich akzeptiere die <a href=\"https://www.mycrifdata.ch/home/agb/\" target=\"_blank\" rel=\"noopener noreferrer\">Allgemeinen Geschäftsbedingungen der CRIF AG</a> und nehme ihre <a href=\"https://www.mycrifdata.ch/home/datenschutz\" target=\"_blank\" rel=\"noopener noreferrer\">Datenschutzerklärung zur Kenntnis.</a>"
      }
    },
    "error": {
      "close": "Schliessen",
      "description": "Es gab einen Fehler.",
      "title": "Hinweis"
    },
    "invoice": {
      "creditCertificate": {
        "title": "BONITÄTSZERTIFIKAT von myCRIFdata",
        "value": "CHF 20.00"
      },
      "freeDebtCollectionMessage": "Als MieterPlus-Benutzer kannst du den Betreibungsauszug gratis bestellen.",
      "officialFee": {
        "title": "Amtliche Gebühr",
        "value": "CHF 17.00"
      },
      "postage": {
        "title": "Porto (A-Post)",
        "value": "CHF 5.00"
      },
      "processingFee": {
        "title": "Bearbeitungsgebühr",
        "value": "CHF 12.90"
      },
      "title": "Rechnung",
      "total": {
        "title": "Total",
        "value": "CHF 0.00"
      }
    },
    "smsNotification": {
      "content": "Bitte beachte, dass deine Bestellung dem Betreibungsamt innert kürzester Zeit kostenpflichtig elektronisch übermittelt wird und diese deshalb nach der Zustellung nicht mehr storniert werden kann.",
      "title": "Wichtige Information"
    },
    "title": "Bestellen",
    "upsell": {
      "checkbox": {
        "content": "Ich möchte meiner Bestellung ein BONITÄTSZERTIFIKAT von myCRIFdata für CHF 20.– hinzufügen."
      },
      "description": "Besorge dir das BONITÄTSZERTIFIKAT von myCRIFdata für CHF 20.– und zeige deine gute Kreditwürdigkeit gegenüber Vermietern und Verwaltungen. Es ist fälschungssicher und branchenweit anerkannt.",
      "example": {
        "link": "Beispiel des Zertifikats anzeigen"
      },
      "title": "Steigere deine Chancen bei der Wohnungsbewerbung"
    }
  },
  "successStep": {
    "info": "Dein Beitreibungsauszug ist unterwegs zu dir. In der Regel erhältst du ihn innert ein paar Stunden per E-Mail oder, falls bestellt, bereits am Folgetag per A-Post.",
    "infoEmail": "Du solltest zudem in Kürze ein Bestätigungsmail auf {emailAddress} erhalten. Bitte überprüfe deinen Posteingang.",
    "moreListingsAvailableMessage": "Schau dir in der Zwischenzeit weitere Wohnungen und Häuser an. Wir haben über 100'000 spannende Inserate für dich!",
    "searchBuyObjectsLabel": "Kaufobjekte suchen",
    "searchRentObjectsLabel": "Mietobjekte suchen",
    "title": "Erfolgreich gesendet"
  },
  "wizardButtons": {
    "back": "Zurück",
    "forFree": {
      "submit": "Gratis bestellen"
    },
    "next": "Weiter",
    "submit": "Bestellen",
    "toPayment": {
      "submit": "Zur Zahlung"
    }
  },
  "wizardPage": {
    "title": "Betreibungsauszug bestellen"
  }
}